import { render } from "./milestone-plan-state-badge.vue?vue&type=template&id=0ce28fea&scoped=true&ts=true"
import script from "./milestone-plan-state-badge.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-state-badge.vue?vue&type=script&lang=ts"

import "./milestone-plan-state-badge.vue?vue&type=style&index=0&id=0ce28fea&lang=scss"
import "./milestone-plan-state-badge.vue?vue&type=style&index=1&id=0ce28fea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce28fea"]])

export default __exports__